import { render, staticRenderFns } from "./PagamentoYapay.vue?vue&type=template&id=0df14da3&"
import script from "./PagamentoYapay.vue?vue&type=script&lang=js&"
export * from "./PagamentoYapay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports